import type { ApiService, Logger } from "@packages/common";
import type { Category, CategoryApiResponseDTO } from "./dtos";

import { API, LOGGER } from "@packages/common";
import { Inject, Injectable } from "@webmotors/ioc";

import { CATEGORY_FALLBACK } from "./categories-fallback";
import { CATEGORIES_SERVICE } from "./categories.types";

@Injectable(CATEGORIES_SERVICE)
export class CategoriesService {
  private readonly logger: Logger;

  constructor(
    @Inject(LOGGER) loggerFactory: Logger,
    @Inject(API) private readonly apiService: ApiService
  ) {
    this.logger = loggerFactory.create(CATEGORIES_SERVICE);
  }

  async get(): Promise<Category[]> {
    try {
      const response = await this.apiService.get<
        unknown,
        CategoryApiResponseDTO[]
      >("/category");

      const categories: Category[] = (response || CATEGORY_FALLBACK).map(
        (category: CategoryApiResponseDTO) => ({
          name: category?.Nome ?? "",
          alt: category?.Nome ? `Banner ${category.Nome}` : "",
          url: category?.Url ?? "",
          category: category?.Categoria ?? "",
          categoryName: category?.NomeCategoria ?? "",
          primaryColor: category?.CorPrimaria ?? "",
          secondaryColor: category?.CorSecundaria ?? "",
          bannerDesktop: category?.BannerDesktop ?? "",
          cardDesktop: category?.CardDesktop ?? "",
          bannerMobile: category?.BannerMobile ?? "",
          cardMobile: category?.CardMobile ?? "",
          description: category?.Descricao ?? "",
        })
      );

      return categories ?? [];
    } catch (error) {
      this.logger.error("[Get] Error fetching categories: ", error);

      const categories: Category[] = CATEGORY_FALLBACK.map((category) => ({
        name: category?.Nome ?? "",
        alt: category?.Nome ? `Banner ${category.Nome}` : "",
        url: category?.Url ?? "",
        category: category?.Categoria ?? "",
        categoryName: category?.NomeCategoria ?? "",
        primaryColor: category?.CorPrimaria ?? "",
        secondaryColor: category?.CorSecundaria ?? "",
        bannerDesktop: category?.BannerDesktop ?? "",
        cardDesktop: category?.CardDesktop ?? "",
        bannerMobile: category?.BannerMobile ?? "",
        cardMobile: category?.CardMobile ?? "",
        description: category?.Descricao ?? "",
      }));

      return categories;
    }
  }
}
